import React from 'react'
import { DURATE_DISPONIBILI, PACCHETTI, CAUSALI, TIPI_VEICOLO, valoreVeicoloValido, richiedePolizza, durataFissa, causaleToStatoVeicolo, validaCausaleNuova, validaCausaleRinnovo, GIORNI_MAX_NUOVA, isAutocarriIntermediari, PESI_AUTOCARRO } from '../../lib/validazioni'

const DURATE_LOJACK = [12, 24, 36, 48, 60, 72]

export default function StepDatiComuni({ data, update, updateComuni, province, ruoloUtente, tipoOperazione }) {
  const dc = data.dati_comuni
  const isAutocarri = isAutocarriIntermediari(tipoOperazione)
  const valoreCheck = valoreVeicoloValido(dc.valore_auto, tipoOperazione)
  const mostraSezioniPolizza = richiedePolizza(tipoOperazione)
  const durataBloccata = durataFissa(tipoOperazione, dc.causale)  // 12 per "annuali" o causale "rinnovo"
  const motivoBlocco =
    isAutocarri ? 'Le polizze autocarri intermediari hanno durata fissa di 12 mesi.'
    : tipoOperazione === 'annuali' ? 'Le polizze annuali hanno durata fissa di 12 mesi.'
    : dc.causale === 'rinnovo'   ? 'Per i rinnovi la durata è sempre 12 mesi (rinnovo annuale).'
    : null

  // Calcola anni veicolo dall'immatricolazione, se presente
  const etaVeicolo = (() => {
    if (!dc.immatricolazione) return null
    const d = new Date(dc.immatricolazione)
    if (isNaN(d.getTime())) return null
    const anni = (Date.now() - d.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
    return Math.floor(anni)
  })()

  // Seriale satellitare obbligatorio ogni volta che il cliente dichiara di avere
  // già un satellitare installato (serve per verifica antifrode / centrale H24).
  const richiedeSeriale = true

  return (
    <div>
      <div className="info-box mt-1" style={{ marginBottom: '1.5rem' }}>
        {mostraSezioniPolizza
          ? <>Dati comuni a tutte le polizze. Compila qui le informazioni cliente e veicolo, poi vedrai la comparazione delle compagnie disponibili.</>
          : <>Inserisci i dati anagrafici del cliente e gli identificativi del veicolo (targa, marca, modello). Per la modalità <strong>Solo Stand-alone</strong> non servono dati di polizza CVT.</>
        }
      </div>

      <div className="section-title">Cliente</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <div className="form-group">
          <label>{dc.is_societa ? 'Ragione sociale / Referente' : 'Nome'} <span className="req">*</span></label>
          <input value={data.cliente_nome} maxLength={100}
                 onChange={e => update({ cliente_nome: e.target.value.replace(/[\r\n\t]/g, '') })}
                 placeholder={dc.is_societa ? 'Es. Rossi S.r.l.' : 'Mario'} />
        </div>
        <div className="form-group">
          <label>{dc.is_societa ? 'Codice fiscale società' : 'Cognome'} <span className="req">*</span></label>
          <input value={data.cliente_cognome} maxLength={100}
                 onChange={e => update({ cliente_cognome: e.target.value.replace(/[\r\n\t]/g, '') })}
                 placeholder={dc.is_societa ? 'P.IVA o CF' : 'Rossi'} />
        </div>
      </div>

      <div className="form-group">
        <label className="check-row" style={{ cursor: 'pointer', userSelect: 'none' }}>
          <input
            type="checkbox"
            checked={!!dc.is_societa}
            onChange={e => updateComuni({ is_societa: e.target.checked })}
          />
          <span style={{ marginLeft: 8 }}>
            <strong>Intestazione a società</strong>
            <div className="text-small text-muted">
              Se attivo, sarà richiesta la <strong>visura camerale</strong> tra i documenti da allegare.
            </div>
          </span>
        </label>
      </div>

      {/* Identificativi veicolo: obbligatori per TUTTI (anche solo_standalone) */}
      <div className="section-title">Veicolo — identificativi</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem' }}>
        <div className="form-group">
          <label>Targa <span className="req">*</span></label>
          <input
            value={dc.targa || ''}
            maxLength={15}
            onChange={e => updateComuni({ targa: e.target.value.replace(/[\r\n\t\s]/g, '').toUpperCase() })}
            placeholder="Es. AB123CD"
          />
        </div>
        <div className="form-group">
          <label>Marca <span className="req">*</span></label>
          <input
            value={dc.marca_veicolo || ''}
            maxLength={50}
            onChange={e => updateComuni({ marca_veicolo: e.target.value.replace(/[\r\n\t]/g, '') })}
            placeholder="Es. Fiat, Volkswagen..."
          />
        </div>
        <div className="form-group">
          <label>Modello e Allestimento <span className="req">*</span></label>
          <input
            value={dc.modello_veicolo || ''}
            maxLength={80}
            onChange={e => updateComuni({ modello_veicolo: e.target.value.replace(/[\r\n\t]/g, '') })}
            placeholder="Es. Panda 1.2, Golf 2.0 TDI..."
          />
        </div>
      </div>

      {mostraSezioniPolizza && <>
      <div className="section-title">Veicolo</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <div className="form-group">
          <label>{isAutocarri ? 'Valore veicolo (EUR)' : 'Valore auto (EUR)'} <span className="req">*</span></label>
          <input type="number" min="0" max={isAutocarri ? '300000' : '200000'} value={dc.valore_auto}
                 onFocus={e => e.target.select()}
                 onChange={e => updateComuni({ valore_auto: e.target.value })} placeholder="20000" />
          {!valoreCheck.ok && dc.valore_auto !== '' && <div className="hint warn">{valoreCheck.msg}</div>}
        </div>
        <div className="form-group">
          <label>Data immatricolazione <span className="req">*</span></label>
          <input type="date" value={dc.immatricolazione || ''}
                 max={new Date().toISOString().split('T')[0]}
                 onChange={e => updateComuni({ immatricolazione: e.target.value })} />
          {etaVeicolo !== null && <div className="hint">Veicolo di {etaVeicolo} {etaVeicolo === 1 ? 'anno' : 'anni'}</div>}
          {dc.immatricolazione && new Date(dc.immatricolazione) > new Date() && (
            <div className="error-msg show">La data di immatricolazione non può essere nel futuro.</div>
          )}
        </div>
        <div className="form-group" style={{ gridColumn: '1 / -1' }}>
          <label>Tipologia veicolo <span className="req">*</span></label>
          {isAutocarri ? (
            <>
              <input value="Autocarro" disabled readOnly />
              <div className="hint">Tipologia bloccata per questa polizza intermediari.</div>
            </>
          ) : (
            <div className="radio-group">
              {TIPI_VEICOLO.map(t => (
                <div key={t.value}
                     className={`radio-btn ${(dc.categoria_veicolo || 'auto') === t.value ? 'selected' : ''}`}
                     onClick={() => updateComuni({ categoria_veicolo: t.value })}>
                  {t.label}
                </div>
              ))}
            </div>
          )}
          {(dc.categoria_veicolo === 'autocarro' && !isAutocarri) && (
            <div className="hint warn">
              ⚠ Massa massima ammessa per autocarri: <strong>35 quintali (3.500 kg)</strong>.
            </div>
          )}
        </div>

        {isAutocarri && (
          <div className="form-group" style={{ gridColumn: '1 / -1' }}>
            <label>Peso autocarro <span className="req">*</span></label>
            <div className="radio-group">
              {PESI_AUTOCARRO.map(p => (
                <div key={p.value}
                     className={`radio-btn ${dc.peso_autocarro === p.value ? 'selected' : ''}`}
                     onClick={() => updateComuni({ peso_autocarro: p.value })}>
                  {p.label}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="form-group" style={{ gridColumn: '1 / -1' }}>
          <label>Causale <span className="req">*</span></label>
          <div className="radio-group">
            {CAUSALI.map(c => (
              <div key={c.value}
                   className={`radio-btn ${dc.causale === c.value ? 'selected' : ''}`}
                   onClick={() => updateComuni({
                     causale: c.value,
                     stato_veicolo: causaleToStatoVeicolo(c.value),
                   })}
                   title={c.desc}>
                {c.label}
                <div className="text-small text-muted" style={{ fontWeight: 400, marginTop: 2 }}>{c.desc}</div>
              </div>
            ))}
          </div>
          {(() => {
            const vN = validaCausaleNuova(dc.causale, dc.immatricolazione)
            if (!vN.ok) {
              return (
                <div className="info-box amber mt-1" style={{ marginTop: 8 }}>
                  ⚠ {vN.msg}
                </div>
              )
            }
            const vR = validaCausaleRinnovo(dc.causale, dc.immatricolazione)
            if (!vR.ok) {
              return (
                <div className="info-box amber mt-1" style={{ marginTop: 8 }}>
                  ⚠ {vR.msg}
                </div>
              )
            }
            if (dc.causale === 'nuova' && dc.immatricolazione && vN.giorni !== undefined) {
              return (
                <div className="hint">
                  Veicolo immatricolato {vN.giorni} {vN.giorni === 1 ? 'giorno' : 'giorni'} fa
                  (limite "Nuova": {GIORNI_MAX_NUOVA} giorni).
                </div>
              )
            }
            if (dc.causale === 'rinnovo' && dc.immatricolazione && vR.giorni !== undefined) {
              return (
                <div className="hint">
                  Veicolo immatricolato {vR.giorni} giorni fa (rinnovo: serve veicolo &gt; {GIORNI_MAX_NUOVA} giorni).
                </div>
              )
            }
            return null
          })()}
        </div>
        {!isAutocarri && <div className="form-group">
          <label>Satellitare presente</label>
          <div className="radio-group">
            <div className={`radio-btn ${dc.satellitare ? 'selected' : ''}`}
                 onClick={() => updateComuni({ satellitare: true, acquista_lojack: false, mesi_lojack: null })}>Sì</div>
            <div className={`radio-btn ${!dc.satellitare ? 'selected' : ''}`}
                 onClick={() => updateComuni({ satellitare: false, sat_marca: '', sat_seriale: '' })}>No</div>
          </div>
          {dc.satellitare && <div className="hint">Lo sconto si applica solo se il sat ha centrale operativa H24.</div>}
        </div>}
        {!isAutocarri && dc.satellitare && (
          <>
            <div className="form-group">
              <label>Marca satellitare <span className="req">*</span></label>
              <input value={dc.sat_marca || ''} maxLength={100}
                     onChange={e => updateComuni({ sat_marca: e.target.value.replace(/[\r\n\t]/g, '') })}
                     placeholder="Es. IoT Telematico, K100Net, OTRAK, Futur One, On Board" />
              <div className="hint">Necessaria per verificare la C.O. H24 e applicare lo sconto.</div>
            </div>
            {richiedeSeriale && (
              <div className="form-group">
                <label>Seriale satellitare <span className="req">*</span></label>
                <input value={dc.sat_seriale || ''} maxLength={100}
                       onChange={e => updateComuni({ sat_seriale: e.target.value.replace(/[\r\n\t]/g, '') })}
                       placeholder="Codice seriale del dispositivo" />
                <div className="hint">Codice identificativo univoco del dispositivo installato sul veicolo (obbligatorio).</div>
              </div>
            )}
          </>
        )}
        {!isAutocarri && !dc.satellitare && (
          <div className="form-group">
            <label>Vuoi acquistare il satellitare?</label>
            <div className="radio-group">
              <div className={`radio-btn ${dc.acquista_lojack ? 'selected' : ''}`}
                   onClick={() => updateComuni({ acquista_lojack: true, mesi_lojack: dc.mesi_lojack || (DURATE_LOJACK.includes(parseInt(dc.durata_mesi, 10)) ? parseInt(dc.durata_mesi, 10) : 12) })}>Sì</div>
              <div className={`radio-btn ${!dc.acquista_lojack ? 'selected' : ''}`}
                   onClick={() => updateComuni({ acquista_lojack: false, mesi_lojack: null })}>No</div>
            </div>
            {dc.acquista_lojack && (
              <>
                <div className="form-group" style={{ marginTop: 10 }}>
                  <label>Mesi satellitare <span className="req">*</span></label>
                  <select
                    value={dc.mesi_lojack || ''}
                    onChange={e => updateComuni({ mesi_lojack: parseInt(e.target.value, 10) })}
                  >
                    <option value="">Seleziona...</option>
                    {DURATE_LOJACK.map(m => <option key={m} value={m}>{m} mesi</option>)}
                  </select>
                </div>
                <div className="hint">Costo: fisso satellitare + quota extra in base ai mesi selezionati.</div>
              </>
            )}
          </div>
        )}
      </div>

      <div className="section-title">Polizza</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <div className="form-group">
          <label>Provincia di residenza <span className="req">*</span></label>
          <select value={dc.provincia} onChange={e => updateComuni({ provincia: e.target.value })}>
            <option value="">Seleziona...</option>
            {province.map(p => <option key={p.sigla} value={p.sigla}>{p.sigla} - {p.nome} ({p.regione})</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Durata <span className="req">*</span></label>
          {durataBloccata ? (
            <>
              <input value="12 mesi" disabled readOnly />
              <div className="hint">{motivoBlocco}</div>
            </>
          ) : (
            <select value={dc.durata_mesi} onChange={e => updateComuni({ durata_mesi: parseInt(e.target.value) })}>
              {DURATE_DISPONIBILI.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
            </select>
          )}
        </div>
      </div>

      {/* Mesi valore a nuovo: applicabile SOLO per causale "Usata" (voltura).
          Su Nuova il VAN è già incluso di default nel tasso; su Rinnovo non si applica VAN
          (è un rinnovo della polizza furto/incendio annuale, niente VAN integrativo). */}
      {!isAutocarri && dc.causale === 'usata' && (
        <div className="form-group" style={{ gridColumn: '1 / -1', background: 'var(--purple-soft)', padding: '14px', borderRadius: 'var(--radius)' }}>
          <label>
            Mesi valore a nuovo richiesti
          </label>
          <input type="number" min="0" max={dc.durata_mesi || 36}
                 value={dc.mesi_valore_a_nuovo ?? ''}
                 onFocus={e => e.target.select()}
                 onChange={e => {
                   const v = e.target.value
                   updateComuni({ mesi_valore_a_nuovo: v === '' ? null : parseInt(v, 10) })
                 }}
                 placeholder={`lascia vuoto = solo 1° anno obbligatorio · max ${dc.durata_mesi || 36}`} />
        </div>
      )}

      {!isAutocarri && <div className="form-group">
        <label>Pacchetto <span className="req">*</span></label>
        <div className="radio-group">
          {PACCHETTI.map(p => (
            <div key={p.value}
                 className={`radio-btn ${dc.pacchetto === p.value ? 'selected' : ''}`}
                 onClick={() => updateComuni({ pacchetto: p.value })}>
              {p.label}
            </div>
          ))}
        </div>
        <div className="hint">
          Il pacchetto viene mappato per ogni compagnia: BASE→START/Base, PLUS→ADVANCED/Medium.
          Le compagnie con varianti specifiche (Collisione, Kasko) sono visibili nel comparatore.
        </div>
      </div>}
      </>}
    </div>
  )
}
